import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

interface ErrorPageProps {
  icon: LucideIcon
  title: string
  description: string
  action?: ReactNode
}

export function ErrorPage({
  icon: Icon,
  title,
  description,
  action,
}: ErrorPageProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8 text-center">
      <div className="mb-4 rounded-full bg-red-50 p-4">
        <Icon className="h-12 w-12 text-red-500" />
      </div>
      <h2 className="mb-2 text-2xl font-semibold text-gray-900">{title}</h2>
      <p className="mb-6 max-w-md text-gray-600">{description}</p>
      {action && <div className="flex gap-3">{action}</div>}
    </div>
  )
}
